export function MiraseeLogo({ class: className, href }: { class?: string; href?: string }) {
  return (
    <a href={href || '/'} class={`no-underline ${className || ''}`}>
      <img src="/icons/mirasee-logo.png" alt="Mirasee" style="height: 36px; width: auto" />
    </a>
  );
}
